// Territory visual images — large pool with hash-based unique assignment
// Every territory gets a unique image based on its ID hash

const TERRITORY_IMAGE_POOL = [
  // Brooklyn streets & corners
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/c0cb6ca16d4b4367487103280060cc621d05074bdf40bc4e3239e45b459ceaa1.jpeg',
  // Warehouse/industrial
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/df99c8f0af6c001c68e46c23a0344b916b640e769076d6d04e608de8628a2911.jpeg',
  // Transit/subway
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/68f908ec3fb77c229ed8a56f9cc72293bc88e5944a0dd6510cbdaaf9d61d3c9f.jpeg',
  // Bodega row
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/3653178fd5a3b7945f55dcc43569090137b947528b85278eece3dfe93a653fa0.jpeg',
  // Projects
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/2e20286b4b3d1fd0113b38f20b93266cc64f49ba1bafce5bbe9a1148a37dd7af.jpeg',
  // Commercial avenue
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/12eef054885f3686a04c11bd5d8182a49722474b534d794924e810d877c664c4.jpeg',
  // Waterfront docks
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/1b80b6163357505d9b5576a8c0a42985323a64c759574354f9e9938e3470ee7d.jpeg',
  // Italian restaurant
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/65dc1e304541284549585bdf79e4743aa4b20981d7f7bbd953a7a9706be498e5.jpeg',
  // Russian neighborhood
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/3d09401d3a08f1fcd5741bb980a00015c5a140c9d945bc78a930acacbf42ed7c.jpeg',
  // Pipeline highway
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/5f94dce950d3bd39dd86390adfcbe19c1386e59bd1cb556c94b43d8ede7cd887.jpeg',
  // Electronics warehouse
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/3fe7f0eea63c265c3f962f13dbd434e41073844202c6e7945163b2b5bdda9099.jpeg',
  // Harlem uptown
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/e0f17c545e94e9e70f6b4940a910ee6dae02acc4d74b8a6de360c3663a75bcdc.jpeg',
  // Atlantic City casino
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/2f18d0eb6e07186496321c77e8f0cd63bedb5ac33e746728d4013efb2ecd46fc.jpeg',
  // Corporate tower
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/a6aad4c53e13ce3b41464f1709a478668b3f249b18073942d18126e90c1e1bb7.jpeg',
  // Crypto mining
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/86dc0318b13d80d84d73642892bfe21920c39a510f63997c8c6a7a6ea72c50c1.jpeg',
  // Luxury estate
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/ef6e3fc301415d16c6c3ff0ddcff5edaa5941dbde60dc1ce571eaabee338d8b2.jpeg',
  // Prison corridor
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/71763263624b511783fdb09221eee82f275e8f32514f49374b57cc75589431e2.jpeg',
  // Brighton Beach boardwalk
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/4886700b652eba97160b4a7eb62fe2c27a10be5374e0e45078812c85b71a6798.jpeg',
  // Russian arms cache
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/0d8f11e2771e22427ab9904d83abe3a38bfd72710f292843c4216159da76e207.jpeg',
  // Sheepshead Bay marina
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/9709786bf1eb7cb1b72b5e7e908c7ccc061398c0108d15b5db76c8ee83f30dd9.jpeg',
  // Distribution warehouse
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/74d92dbcb2fb634b3623ec4d4981f94e867a32509314e55f491f854df28f6529.jpeg',
  // Atlanta Bankhead
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/2ba91a07a2296d43b1a3af35fc5e03c77968aa29b3cec2618ec895e91b3d6c36.jpeg',
  // Atlanta College Park
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/45b6d6c4d5ca8b309140605c1245f1a72b713e45ca43b9a301df2b2acad07ebe.jpeg',
  // Bed-Stuy rooftops
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/c9cb65c6010e8efad0d82a65c3d33617cb33b7806b477b71f563d54a97fa6234.jpeg',
  // Crown Heights intersection
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/9bef07c210bde2a45d5d0553de76a5429b39008a530b5126842e23e727c7ef46.jpeg',
  // Flatbush Avenue
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/1ec8edee44204543acac7bd04374f73b6759bb199e88f8b1cc89d8ff840e0cb3.jpeg',
  // Parking garage
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/3919350855104507a0cee3b83fa3e6c0aefa3c64b65407a006a48d00a0f189d5.jpeg',
  // Abandoned factory
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/c182587e031dee50774545eb9dee32d7bdb3b9b9853e4692289633de4b964adb.jpeg',
  // Laundromat
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/09a6c963be35fbe1101cca1c79154d3d704771d7ae7e834eb9171f0a65767ec0.jpeg',
  // Church
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/8130702b5bc0f46552fcdc47c00ca10477f924abf67dfc0081a2d9cbe91bcaea.jpeg',
  // Basketball court
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/8cea117e1fc881191e2136d69b10a2be9548f94b3fe25ceee3e8c00ed0aab865.jpeg',
  // Pawn shop
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/c730be2ee44c30447a09b3a4ae8a570120c37f40201aff9ea75a55b2f34724f9.jpeg',
  // Nightclub
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/e45c4c11755815996d01178d90e286dac0f051610826d7c0eaa4e292363488b1.jpeg',
  // Fish market
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/d5d51fe58226bbd1898e98f594d09503f274bdd25491a3f58f2620cd3b54e234.jpeg',
  // Houston skyline
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/d7565534911f7c5c669bee49d3ecaed5b5295f65611accb339d7b058f50fa52e.jpeg',
  // Dallas downtown
  'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/d5947b2474e7316230ded0677d6f72c024ec9cbf52043b97e142d02e06345fc6.jpeg',
];

// Deterministic hash — same territory ID always gets same image
function hashId(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

/**
 * Get a unique territory image based on territory ID.
 * Uses hash so each territory consistently gets its own image.
 */
export function getTerritoryImage(territory) {
  const id = territory.id || territory.name || 'default';
  const idx = hashId(id) % TERRITORY_IMAGE_POOL.length;
  return TERRITORY_IMAGE_POOL[idx];
}

export default TERRITORY_IMAGE_POOL;
